module.exports = __webpack_public_path__ + "img/glasgow-warriors-logo-icon.23b692dd.png";